import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography
} from '@mui/material';
import { useLazyQuery, useApolloClient } from '@apollo/client';
import { JSONToTable } from '../../table/JSONToTable';
import { USER_PREFERENCES_QUERY, USER_FAVOURITES_QUERY } from '../../../graph/UserGraph';
import PageLoadingSkeleton from '../../skeletons/PageLoadingSkeleton';



const GeneralSettings = (props) => {
  const [getLazyPreferences, lazyPreferences] = useLazyQuery(USER_PREFERENCES_QUERY, { notifyOnNetworkStatusChange: true, });

  useEffect(() => {
    getLazyPreferences()
    // getLazyFavourites()
  }, [])

  useEffect(() => {
    // console.log(lazyPreferences, "these are user preferences")
    // getLazyFavourites()
  }, [lazyPreferences])

  // if (lazyPreferences == null || lazyPreferences == undefined) return <TableLoadingSkeleton variant={"rectangular"} marginX={1} marginY={8} count={5} />

  return (

    <Card>
      <CardHeader
        subheader="Manage general settings across the platform"
        title="General"
      />
      <Divider />
      <CardContent>

        {lazyPreferences.data == undefined || lazyPreferences.data == null
          ? <PageLoadingSkeleton variant={"rectangular"} marginx={1} marginy={1} count={1} height={500} />
          : <JSONToTable data={lazyPreferences.data} keysToExclude={["id", "__typename"]} />
        }
      </CardContent>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <Button
          color="primary"
          variant="contained"
        >
          Save
        </Button>
      </Box>
    </Card>

  )
};

export default GeneralSettings;
